export const c_skeleton_m_height_33_Height = {
  "name": "--pf-c-skeleton--m-height-33--Height",
  "value": "calc(100% / 3)",
  "var": "var(--pf-c-skeleton--m-height-33--Height)"
};
export default c_skeleton_m_height_33_Height;